export default __webpack_public_path__ + "static/press_3_orig-2307f84c2cb841582b9cdc5a74ceb50f.jpg";